export default __webpack_public_path__ + "static/media/firstMobile.2c81e0ef.svg";